<template>
	<div class="global-footer-certificates">
		<ul>
			<li
				v-for="(certificateItem, $index) in certificateData"
				:key="$index"
			>
				<component
					:is="certificateItem.anchorProperties.href ? 'a' : 'span'"
					v-bind="{ ...certificateItem.anchorProperties }"
					v-metric="certificateItem.anchorProperties.metric"
					@click.prevent="interstitialCheck"
				>
					<img v-bind="{ ...certificateItem.imageProperties }" />
				</component>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	name: 'FooterCertificates',
	props: {
		certificateData: {
			type: Array,
			required: true,
		},
		interstitialCheck: {
			type: Function,
			required: true,
		},
	},
};
</script>
